import * as z from "zod/v4";
import { UlidSchema } from "./ulid.ts";
import { IsoDateTimeSchema } from "./iso.ts";
import { UIMessageSchema } from "../ai-sdk/ui-message.ts";
import { type ChatMessage } from "./chat-message.ts";
import { ResultSchemaOf } from "./result.ts";
import { ulid } from "@std/ulid";

export const ConversationSchema = z.object({
  id: UlidSchema,
  agent_id: UlidSchema,
  project_id: UlidSchema,
  title: z.string(),
  created_at: IsoDateTimeSchema,
  updated_at: IsoDateTimeSchema,
});

export type Conversation = z.infer<typeof ConversationSchema>;

export const UpsertConversationSchema = z.object({
  project_id: UlidSchema,
  agent_id: UlidSchema,
  title: z.string().optional(),
});

export type UpsertConversation = z.infer<typeof UpsertConversationSchema>;

export const CreateConversationSchema = z.object({
  id: UlidSchema.default(ulid),
  project_id: UlidSchema,
  agent_id: UlidSchema,
});

export type CreateConversation = z.infer<typeof CreateConversationSchema>;

export const ConversationMessagesSchema = z.object({
  id: UlidSchema,
  agent_id: UlidSchema,
  project_id: UlidSchema,
  title: z.string(),
  created_at: IsoDateTimeSchema,
  updated_at: IsoDateTimeSchema,
  messages: z.array(UIMessageSchema),
});

export type ConversationMessages = Omit<
  z.infer<typeof ConversationMessagesSchema>,
  "messages"
> & {
  messages: ChatMessage[];
};

export const ConversationMessagesResultSchema = ResultSchemaOf(
  ConversationMessagesSchema,
  z.string(),
);

export type ConversationMessagesResult =
  | { ok: true; value: ConversationMessages }
  | { ok: false; error: string };
